// extracted by mini-css-extract-plugin
export default {"gridContent":"factSheetContent_gridContent__BM2dN","px12py4":"factSheetContent_px12py4__Sjec9","reportItemButton":"factSheetContent_reportItemButton__l7bOy"};